import request from '@/utils/requestSupplier'

//供应商登录
export function sellerLogin (username, password) {
  return request({
    url: '/admin/mchtLogin',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

//获取当前登录用户信息
export function getInfo () {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

//平台登录
export function platformLogin (username, password) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}
// 获取平台用户信息
export function getPlatformInfo () {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/supplierLogin.js